import PauseMonitoringModal from './PauseMonitoringModal';
import { IPauseMonitoringFormValues } from './types';

export default PauseMonitoringModal;
export type { IPauseMonitoringFormValues };
